import { jsxs, jsx } from "react/jsx-runtime";
const IconRulerSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 20 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M17.501 2.167h-15A.833.833 0 0 0 1.668 3v15a.833.833 0 0 0 .833.833h5A.833.833 0 0 0 8.335 18V8.833H17.5A.833.833 0 0 0 18.335 8V3a.834.834 0 0 0-.834-.833Zm-.833 5h-1.667v-.834a.833.833 0 1 0-1.666 0v.834h-1.667v-.834a.833.833 0 1 0-1.667 0v.834H8.335v-.834a.833.833 0 0 0-1.667 0v.834h-.833a.833.833 0 1 0 0 1.666h.833V10.5h-.833a.833.833 0 1 0 0 1.667h.833v1.666h-.833a.834.834 0 0 0 0 1.667h.833v1.667H3.335V3.833h13.333v3.334Z" })
    ]
  }
);
export {
  IconRulerSvg
};
